import { render, staticRenderFns } from "./roundTable.vue?vue&type=template&id=5f373d1c&scoped=true&"
import script from "./roundTable.vue?vue&type=script&lang=js&"
export * from "./roundTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f373d1c",
  null
  
)

export default component.exports